/*
 * Application Insights JavaScript SDK - Core, 3.0.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


//  @skip-file-minify
import { createEnumStyle } from "../JavaScriptSDK.Enums/EnumHelperFuncs";
export var LoggingSeverity = createEnumStyle({
    DISABLED: 0 /* eLoggingSeverity.DISABLED */,
    CRITICAL: 1 /* eLoggingSeverity.CRITICAL */,
    WARNING: 2 /* eLoggingSeverity.WARNING */
});
//# sourceMappingURL=LoggingEnums.js.map